/* global SnapEngage */

import _ from 'underscore';
import $ from 'jquery';
import crypto from 'crypto-js';
import cookies from 'js-cookie';
import user from './user-info';
import parseParams from './parse-parameters';
import secrets from './secrets';
import { setAttributionTracking } from './attribution-tracking';

const twentyYears = 7300; // JS Cookie - 1 is 1 day
const helperCookies = {
  setShopKeepCookiesObject() {
    window.addEventListener('load', () => {
      if (typeof SnapEngage === 'undefined') {
        return;
      }

      SnapEngage.setCallback('StartChat', () => {
        const encrypted = cookies.get('_sk_leadInfo_2');
        let userInfo = {};
        if (encrypted) {
          const decrypted = crypto.AES.decrypt(
            encrypted.toString(),
            secrets.marketoLeadInfo
          );
          userInfo = JSON.parse(decrypted.toString(crypto.enc.Utf8));
          window.shopkeepCookies.userInfo = {
            firstName: userInfo.FirstName || '',
            lastName: userInfo.LastName || '',
            email: userInfo.Email || '',
            phone: userInfo.Phone || '',
            company: userInfo.Company || ''
          };
        }
      });

      SnapEngage.setCallback('Close', () => {
        window.shopkeepCookies.userInfo = {};
      });
    });

    window.shopkeepCookies = {
      deviceType: cookies.get('_sk_deviceType'),
      franchises: cookies.get('_sk_franchises'),
      locations: cookies.get('_sk_locations'),
      ecommerce: cookies.get('_sk_ecommerce'),
      registers: cookies.get('_sk_registers'),
      sales: cookies.get('_sk_sales'),
      interestedInTrial: cookies.get('_sk_interestedInTrial'),
      trial: cookies.get('_sk_trial'),
      visits: cookies.get('_sk_visits'),
      login: cookies.get('_sk_login'),
      lead: cookies.get('_sk_lead'),
      vertical: cookies.get('_sk_vertical'),
      businessType: cookies.get('_sk_businessType'),
      timeline: cookies.get('_sk_timeline'),
      yearsInBusiness: cookies.get('_sk_yearsInBusiness'),
      currentPOS: cookies.get('_sk_currentPOS'),
      onboarding: cookies.get('_sk_onboarding'),
      callback: cookies.get('_sk_callback'),
      userInfo: {}
    };
  },

  setMarketoFields(name, value) {
    const fieldNames = {
      Business_Category__c: 'vertical',
      Business_Category_Type__c: 'businessType',
      Timeline_for_POS__c: 'timeline',
      Years_in_Business__c: 'yearsInBusiness',
      Has_POS_System_Currently__c: 'currentPOS',
      Number_of_Locations__c: 'locations',
      Number_of_Registers__c: 'registers',
      eCommerce__c: 'ecommerce',
      Average_Monthly_Sales__c: 'sales',
      Callback_Requested__c: 'callback'
    };
    const onboardingCookies = ['sales', 'locations', 'registers'];
    const cookieName = fieldNames[name];

    cookies.set(`_sk_${cookieName}`, value, { expires: twentyYears });

    if (onboardingCookies.indexOf(cookieName) > -1) {
      this.setOnboardingCookie();
    }

    if (cookieName !== 'vertical') {
      cookies.set('_sk_marketoSetBusinessType', true, { expires: twentyYears });
    }

    if (window.shopkeepCookies) {
      window.shopkeepCookies[cookieName] = value;
    }
  },

  setMarketoLead() {
    if (cookies.get('_sk_lead')) return;
    cookies.set('_sk_lead', 'yes', { expires: twentyYears });
    window.shopkeepCookies.lead = 'yes';
  },

  setMarketoLeadInfo(form) {
    if (!_.isUndefined(form.vals().Partner_Email__c)) return;
    const vals = form.vals();
    let mktoLeadInfo = {};

    function setCookie() {
      mktoLeadInfo.FirstName = vals.FirstName || mktoLeadInfo.FirstName;
      mktoLeadInfo.LastName = vals.LastName || mktoLeadInfo.LastName;
      mktoLeadInfo.Company = vals.Company || mktoLeadInfo.Company;
      mktoLeadInfo.Email = vals.Email || mktoLeadInfo.Email;
      mktoLeadInfo.Phone = vals.Phone || mktoLeadInfo.Phone;

      const encrypted = crypto.AES.encrypt(
        JSON.stringify(mktoLeadInfo),
        secrets.marketoLeadInfo
      );
      cookies.set('_sk_leadInfo_2', encrypted, { expires: twentyYears });
    }

    if (cookies.get('_sk_leadInfo_2')) {
      const encrypted = cookies.get('_sk_leadInfo_2');
      const decrypted = crypto.AES.decrypt(
        encrypted.toString(),
        secrets.marketoLeadInfo
      );
      mktoLeadInfo = JSON.parse(decrypted.toString(crypto.enc.Utf8));
      setCookie();
    } else {
      setCookie();
    }
  },

  setLogin() {
    // for login link in new desktop nav
    // need timeout for vue
    setTimeout(() => {
      // eslint-disable-next-line func-names
      $('a[data-backoffice-login="true"]').on('click', function(e) {
        e.preventDefault();
        const href = $(this).attr('href');
        cookies.set('_sk_login', 'yes', { expires: twentyYears });
        window.shopkeepCookies.login = 'yes';
        // open link in new tab
        window.open(href, '_blank');
      });
    }, 100);
    if (cookies.get('_sk_login')) return;
    const loginLinksOld = _.toArray(document.querySelectorAll('.login-href'));
    const loginDropdownOld = _.toArray(
      document.querySelectorAll('.nav__top__login')
    );
    const loginLinks = _.toArray(
      document.querySelectorAll('a[for="backoffice-login"]')
    );
    const loginDropdown = _.toArray(
      document.querySelectorAll('.header__login__wrapper')
    );
    const loginButtons = _.toArray(
      document.querySelectorAll('#backoffice-login-submit')
    );
    const loginArray = _.union(
      loginLinksOld,
      loginDropdownOld,
      loginLinks,
      loginDropdown,
      loginButtons
    );
    _.each(loginArray, (val) => {
      val.addEventListener('click', () => {
        helperCookies.setLoginCookie();
      });
    });
  },

  setLoginCookie() {
    cookies.set('_sk_login', 'yes', { expires: twentyYears });
    window.shopkeepCookies.login = 'yes';
  },

  setOnboardingCookie() {
    if (
      cookies.get('_sk_sales') === 'Under $5,000' &&
      cookies.get('_sk_registers') === '1' &&
      cookies.get('_sk_locations') === '1'
    ) {
      cookies.set('_sk_onboarding', 'true', { expires: twentyYears });
    } else {
      cookies.set('_sk_onboarding', 'false', { expires: twentyYears });
    }
  },

  setSignupPageVisit() {
    if (window.location.pathname !== '/signup') return;
    if (cookies.get('_sk_trial') === 'Yes') return;
    cookies.set('_sk_interestedInTrial', 'yes', { expires: twentyYears });
    window.shopkeepCookies.interestedInTrial = 'yes';
  },

  setFranchisePageVisit() {
    if (window.location.pathname !== '/franchises') return;
    cookies.set('_sk_franchises', 'true', { expires: twentyYears });
    window.shopkeepCookies.franchises = 'true';
  },

  setBusinessTypePageVisit() {
    // leaving dead code here because not really sure what _sk_marketoSetBusinessType cookie was supposed to accomplish
    // if (cookies.get('_sk_businessType') && cookies.get('_sk_marketoSetBusinessType')) return;
    if (window.location.pathname.indexOf('/business-types') < 0) {
      return;
    }

    const businessTypes = {
      retail: {
        mktoVertical: 'Retail'
      },

      quick_service_restaurant: {
        mktoVertical: 'Quick-Serve'
      },

      restaurant: {
        mktoVertical: 'Restaurant / Bar',
        mktoType: 'Full Service Restaurant'
      },

      attraction: {
        mktoVertical: 'Retail',
        mktoType: 'Recreation / Entertainment'
      },

      bar: {
        mktoVertical: 'Restaurant / Bar',
        mktoType: 'Drinking Place'
      },

      bakery: {
        mktoVertical: 'Quick-Serve',
        mktoType: 'Bakery'
      },

      boutique: {
        mktoVertical: 'Retail',
        mktoType: 'Clothing / Accessories'
      },

      candy_shop: {
        mktoVertical: 'Retail',
        mktoType: 'Specialty Retail'
      },

      coffee_shop: {
        mktoVertical: 'Quick-Serve',
        mktoType: 'Coffee Shop'
      },

      concession: {
        mktoVertical: 'Quick-Serve',
        mktoType: 'Concessions / Snacks'
      },

      convenience_store: {
        mktoVertical: 'Retail',
        mktoType: 'Grocery / Convenience Store'
      },

      deli: {
        mktoVertical: 'Retail',
        mktoType: 'Grocery / Convenience Store'
      },

      fireworks: {
        mktoVertical: 'Retail',
        mktoType: 'Specialty Retail'
      },

      food_truck: {
        mktoVertical: 'Quick-Serve',
        mktoType: 'Food Truck'
      },

      frozen_yogurt: {
        mktoVertical: 'Quick-Serve',
        mktoType: 'Ice Cream / Yogurt'
      },

      gift_shop: {
        mktoVertical: 'Retail',
        mktoType: 'Gift Shop'
      },

      ice_cream_shop: {
        mktoVertical: 'Quick-Serve',
        mktoType: 'Ice Cream / Yogurt'
      },

      juice_bar: {
        mktoVertical: 'Quick-Serve',
        mktoType: 'Juice Bar'
      },

      kiosk: {
        mktoVertical: 'Retail'
      },

      liquor_store: {
        mktoVertical: 'Retail',
        mktoType: 'Wine / Liquor / Beer'
      },

      pet_shop: {
        mktoVertical: 'Retail',
        mktoType: 'Pet Services'
      },

      specialty_food: {
        mktoVertical: 'Quick-Serve',
        mktoType: 'Specialty Food'
      },

      specialty_retail: {
        mktoVertical: 'Retail',
        mktoType: 'Specialty Retail'
      },

      specialty_services: {
        mktoVertical: 'Retail',
        mktoType: 'Specialty Services'
      },

      winery: {
        mktoVertical: 'Retail'
      },

      wine_shop: {
        mktoVertical: 'Retail',
        mktoType: 'Wine / Liquor / Beer'
      },

      vape_shop: {
        mktoVertical: 'Retail',
        mktoType: 'Vape Shop'
      }
    };

    const path = window.location.pathname
      .replace('/business-types/', '')
      .replace('-pos', '')
      .replace(/-b$/, '')
      .replace(/-/g, '_')
      .replace(/\/$/, ''); // replace possible trailing slash just to be safe

    const businessTypeCookie = businessTypes[path];

    if (!businessTypeCookie) {
      return;
    }

    cookies.set('_sk_vertical', businessTypeCookie.mktoVertical, {
      expires: twentyYears
    });
    window.shopkeepCookies.vertical = businessTypeCookie.mktoVertical;

    if (businessTypeCookie.mktoType) {
      cookies.set('_sk_businessType', businessTypeCookie.mktoType, {
        expires: twentyYears
      });
      window.shopkeepCookies.businessType = businessTypeCookie.mktoType;
    } else {
      cookies.remove('_sk_businessType');
    }
  },

  setVisits() {
    if (cookies.get('_sk_visitsSession')) return;
    let visits = cookies.get('_sk_visits') || 0;
    visits = parseInt(visits, 10);
    cookies.set('_sk_visits', visits + 1, { expires: twentyYears });
    window.shopkeepCookies.visits = visits + 1;
    cookies.set('_sk_visitsSession', 'true');
  },

  setDeviceType() {
    if (cookies.get('_sk_deviceType')) return;
    cookies.set('_sk_deviceType', user.device.type, { expires: twentyYears });
    window.shopkeepCookies.deviceType = user.device.type;
  },

  defineParameterCookies(qsParams) {
    const utmParameters = {
      utm_source: 'utm_source',
      utm_medium: 'utm_medium',
      utm_campaign: 'utm_campaign',
      utm_term: 'utm_term',
      utm_content: 'utm_content',
      poss_username: 'poss_username',
      _advocate_email: '_advocate_email',
      advocate_email: '_advocate_email',
      partner: '_sk_partner',
      xtl_click_id: 'xtl_click_id'
    };

    _.each(utmParameters, (elem, index) => {
      if (cookies.get(elem) === 'undefined') {
        cookies.remove(elem);
      }
      if (qsParams[index] !== null && qsParams[index] !== undefined) {
        cookies.set(elem, decodeURIComponent(qsParams[index]));
      }
    });
  },

  setParameterCookies() {
    const parameters = parseParams(window.location.search);
    if (
      parameters.gclid &&
      (!parameters.gclsrc || parameters.gclsrc.indexOf('aw') !== -1)
    ) {
      cookies.set('gclid', parameters.gclid, { expires: twentyYears });
    }
    if (parameters.subid) {
      cookies.set('subid', parameters.subid, { expires: twentyYears });
    }
    helperCookies.defineParameterCookies(parameters);
    setAttributionTracking(parameters);
  },

  removeResourceCookie() {
    if (window.location.pathname.indexOf('/resources') === -1) {
      cookies.remove('_sk_resource');
    }
  },

  init() {
    helperCookies.setShopKeepCookiesObject();
    helperCookies.setSignupPageVisit();
    helperCookies.setFranchisePageVisit();
    helperCookies.setBusinessTypePageVisit();
    helperCookies.setLogin();
    helperCookies.setVisits();
    helperCookies.setDeviceType();
    helperCookies.setParameterCookies();
    helperCookies.removeResourceCookie();
  }
};

export default helperCookies;
